import {Component, EventEmitter, OnInit, ViewEncapsulation} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../api/api.service';
import { AssistanceBill } from '../../models/assistance-bill';
import { Member } from '../../models/member';
import { ConfService } from '../../services/conf.service';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import {IamService} from '../../services/iam.service';
import {AssistanceBillComment} from '../../models/assistance-billcomment';
import {AssistancePrice} from '../../models/assistance-price';
import {Country} from '../../models/country';
import { CASE_STATUSES } from '../../models/assistancecase';
import { AssistanceBillSvc } from '../assistances/services/assistance-bill.service';
import { TranslateMessageService } from '../../services/translate-message.service';

@Component({
    selector: 'assistance-bills',
    templateUrl: './assistance-bills.component.html',
    styleUrls: ['./assistance-bills.component.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        AssistanceBillSvc, MessageService
    ],
    standalone: false
})
export class AssistanceBillsComponent implements OnInit {

  bills: any[] = [];
  createdBills = new EventEmitter<any>();
  case_id?: number = null;
  assistancecase: any;
  status: number = null;
  member_id: number = null;
  member = new Member();
  total = 0;
  page = 1;
  selectedBill?: AssistanceBill;
  case_country = new Country();
  showNewBillDialog = false;
  showEditBill = false;
  showChargeBillDialog = false;
  showPayBillDialog = false;
  showCommentDialog = false;
  iAm = null;
  selectedServiceName: string;
  selectedProviderName: string;
  billcomment: AssistanceBillComment;
  billcomments: any[] = [];
  price?: AssistancePrice = null;
  isDisabled = new EventEmitter<boolean>();
  disabled = false;
  plan_id
  // Create or update
  status_flag: string;

  showDetailBillDialog = false;
  assistance_bill: AssistanceBill = null;;

  showCreateButton = false;

  constructor(
    public conf: ConfService,
    private api: ApiService,
    private confirmation: ConfirmationService,
    route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private iam: IamService,
    public assistanceBillSvc: AssistanceBillSvc,
    private translateMsgSvc: TranslateMessageService,
    private messageService: MessageService) {
    this.case_id = parseInt(route.snapshot.params['id']);
    if (route.snapshot.params['status'] != null) {
      this.status = parseInt(route.snapshot.params['status']);
    }
    if (route.snapshot.params['member_id'] != null) {
      this.member_id = parseInt(route.snapshot.params['member_id']);
    }
    this.iAm = this.iam.isRole;
  }

  ngOnInit() {
    this.billcomment = new AssistanceBillComment();
    this.price = new AssistancePrice();
    this.selectedBill = new AssistanceBill();

    this.api.assistanceCasesById.get(this.case_id).promise()
      .then(c => {
        this.member = c.member;
        this.case_country = c.country;
        this.assistancecase = c;
        this.plan_id = c.plan.id
      });

    this.api.assistancebillcommentByCaseId.get(this.case_id).all().promise()
      .then(bc => {
        this.billcomments = bc.data;
      });

    this.getBills();
  }

  getBills() {
    this.api.assistancebills.get().filter({case_id: this.case_id})
      .sort('updated_time', true).page(this.page).promise()
      .then(bills => {
        this.bills = bills.data;
        this.total = bills.total;

        if (this.bills.length == 0) {
          this.showCreateButton = true;
        }
      })
      ;
  }

  nextPage($event) {
    this.page = $event.page + 1;
    this.getBills();
  }

  startCreateBill() {
    this.status_flag = 'Create';
    this.showNewBillDialog = true;
    this.price = new AssistancePrice();
    this.createdBills.emit({bill: null});
  }

  onBillCreate(data: any) {
    this.messageService.clear()
    this.showNewBillDialog = false;
    this.isDisabled.emit(true);
    if (!data.bill.id) {
      if (this.assistancecase.status === CASE_STATUSES.STATUS_CLOSE) {
        let message = "Are you sure you want to submit this bill?";
        let header = "Confirmation";
        this.translate.get([header, message])
          .subscribe((res: any) => {
            this.confirmation.confirm({
                message: res[message],
                header: res[header],
                icon: 'fa fa-question-circle',
                accept: () => {
                    this.postBill(data);
                },
                reject: () => {
                  this.isDisabled.emit(false);
                }
            });
          });
      } else {
        this.postBill(data);
      }
    } else {
      this.api.assistancebills.update(data.bill, data.bill.id).promise()
      .then(resp => {
        for (let i = 0; i < this.bills.length; i++) {
          if (this.bills[i].id == resp.id) {
            this.bills[i] = resp;
            break;
          }
        }

        this.translate.get('Assistance bill updated')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'info',
              summary: 'Info',
              detail: `${res}: ${resp.id}`
            });
          });
        this.isDisabled.emit(false);
      })
      .catch(e => {
        this.translate.get('Error updating assistance bill')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `${res}: ${e.error}`
            });
          });
        this.isDisabled.emit(false);
      });
    }
  }

  postBill(data) {
    data.bill.case_id = this.case_id;
    this.api.assistancebills.post(data.bill).promise()
      .then(b => {
        this.isDisabled.emit(false);
        this.bills.unshift(b);
        this.total ++;
        this.translate.get('New assistance bill created')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'info',
              summary: 'Info',
              detail: res
            });
          });
      })
      .catch(e => {
        this.isDisabled.emit(false);
        let error_msg = e.error;
        try{
          error_msg = e.error.error;
          this.translate
            .get(error_msg)
            .subscribe((res: string) => {
              error_msg = res;
            });
        } catch {
          error_msg = e.error;
        }
        
        this.translate.get('Error creating new assistance bill')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `${res}: ${error_msg}`
            });
          });
      });
  }

  onBillCreateCancel() {
    this.showNewBillDialog = false;
  }

  onEditComment(bill: AssistanceBill) {
    this.billcomment = new AssistanceBillComment();
    this.billcomment.bill_id = bill.id;
    this.selectedServiceName = bill.service.name;
    this.selectedProviderName = bill.provider.name;
    this.showCommentDialog = true;
  }

  onUpdateComment() {
    this.messageService.clear()
    this.disabled = true;
    if (this.billcomment.comment != null && this.showCommentDialog == true) {
       this.api.assistancebillcommnets.post(this.billcomment).promise()
        .then(billcomment => {
          this.disabled = false;
          this.billcomments.push(billcomment);
          this.translate.get('Success').subscribe(resp => {
            this.messageService.add({severity: 'success', summary: 'Created', detail: resp});
          });
        })
        .catch(e => {
          this.disabled = false;
          this.translate.get('Error').subscribe(resp => {
            this.messageService.add({severity: 'error', summary: 'Error', detail: `${resp}:${e.error}`});
          });
      });
    }
    this.showCommentDialog = false;
  }

  onCancelComment() {
    this.showCommentDialog = false;
  }

  onEditBill(bill: AssistanceBill) {

    this.status_flag = 'Update';
    this.showNewBillDialog = true;
    this.createdBills.emit({bill: bill});
  }

  onBillUpdate(bill: AssistanceBill) {
    this.messageService.clear()
    this.showEditBill = false;
    this.isDisabled.emit(false);

    this.api.assistancebills.update(bill, bill.id).promise()
      .then(resp => {
        for (let i = 0; i < this.bills.length; i++) {
          if (this.bills[i].id == resp.id) {
            this.bills[i] = resp;
            break;
          }
        }

        this.translate.get('Assistance bill updated')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'info',
              summary: 'Info',
              detail: `${res}: ${resp.id}`

            });
          });
      })
      .catch(e => {
        this.translate.get('Error updating assistance bill')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `${res}: ${e.error}`
            });
          });
      });
  }

  onBillEditCancel() {
    this.showEditBill = false;
  }

  onBillCharge(bill: AssistanceBill) {
    this.messageService.clear()
    this.showChargeBillDialog = false;
    this.api.assistanceBillsByIdCharge.put(bill).promise()
      .then(b => {
        this.isDisabled.emit(false);
        _.assign(bill, b);
        this.translate.get('Assistance bill charged')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'info',
              summary: 'Info',
              detail: res}
              );
          });

      })
      .catch(e => {
        this.isDisabled.emit(false);
        this.translate.get('Error charging assistance bill')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `${res}: ${e.error}`
            });
          });
      })
      ;
  }

  startChargeBill(bill: AssistanceBill) {
    this.showChargeBillDialog = true;
    this.selectedBill = bill;
  }

  startPayBill(bill: AssistanceBill) {
    this.showPayBillDialog = true;
    this.selectedBill = bill;
  }

  onBillPay(bill: AssistanceBill) {
    this.messageService.clear()
    this.showPayBillDialog = false;
    this.api.assistanceBillsByIdPay.put(bill).promise()
      .then(b => {
        this.isDisabled.emit(false);
        _.assign(bill, b);
        this.translate.get('Assistance bill paid')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'info',
              summary: 'Info',
              detail: res}
              );
          });
      })
      .catch(e => {
        this.isDisabled.emit(false);
        this.translate.get('Error paying assistance bill')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `${res}: ${e.error}`
            });
          });
      })
      ;
  }

  fetchPrice() {
    this.price = new AssistancePrice();
    // this.distapi.getRodaDistanceTIme();
    if (this.selectedBill.provider_id != null && this.selectedBill.service_id != null) {
      this.api.assistancePricesProvidersByIdservicesById.get(this.selectedBill.provider_id, this.selectedBill.provider_site_id, this.selectedBill.coverage_id, this.selectedBill.service_id).promise()
      .then(price => {
            this.price = price;
        })
      .catch(e => this.messageService.add({severity: 'error', summary: 'Error', detail: `Error assistance price: ${e.error}`}));
    }
  }

  onLoadPrice(price: AssistancePrice) {
    this.price = price;
  }

  sendBillToSap(bill: AssistanceBill) {
    this.api.assistancebills.sendBillToSAP(bill.id).promise()
      .then((updatedBill) => {
        Object.assign(bill, updatedBill);
        this.translateMsgSvc.addMessageToMessages(
          {
            severity: 'info',
            summary: 'Info',
            detail: 'Orden de Compra colocada en SAP'
          },
          this.messageService
        );
      })
      .catch(e => {
        this.translateMsgSvc.addMessageToMessages(
          {
            severity: 'error',
            summary: 'Error',
            detail: 'Error sending bill'
          },
          this.messageService
        );
      });
  }

  canSendSap(bill) {
    return this.iAm([
      'assistance_admin', 'supervisor', 'operator', 'cabin_agent', 'teledoctor_agent', 'networkleader',
      'product supervisor'
    ]) && bill.sap_status == this.assistanceBillSvc.SAP_STATUS_PENDING;
  }

  showDetailBill(assistance_bill: AssistanceBill) {
    this.assistance_bill = null;
    this.showDetailBillDialog = true;
    setTimeout(() => {
      this.assistance_bill = assistance_bill;
      setTimeout(() => {
        this.createdBills.emit({ bill: assistance_bill });
      }, 50);
    }, 50);
  }

}
